import React from 'react';
import { ConnectedResidentDiscount } from './ResidentDiscount';
import { ResidentDiscountMessageDesktop } from './ResidentDiscountMessageDesktop';
import { ABUtils } from '../../utils';

export const ResidentDiscount = () => {
    const { isResidentDiscountPaxType } = ABUtils.getABs();

    return (
        <ConnectedResidentDiscount>
            {({ hasNonAdults, hasRegions, regionsText }) =>
                hasRegions ? (
                    <div className="odf-space-inner-bottom-s">
                        <ResidentDiscountMessageDesktop
                            hasNonAdults={hasNonAdults}
                            regionsText={regionsText}
                            isResidentDiscountPaxType={isResidentDiscountPaxType}
                        />
                    </div>
                ) : null
            }
        </ConnectedResidentDiscount>
    );
};
